import { render, staticRenderFns } from "./IndicatorLight.vue?vue&type=template&id=cace0068&"
import script from "./IndicatorLight.vue?vue&type=script&lang=ts&"
export * from "./IndicatorLight.vue?vue&type=script&lang=ts&"
import style0 from "./IndicatorLight.vue?vue&type=style&index=0&id=cace0068&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports